<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div v-if="service._id" class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ service.title }}</h3>
            <p class="text-center">{{ service.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات درگاه</h4>
          </div>
          <div class="widget-body">
            <form id="serviceForm" class="form-horizontal">
              <!-- service name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام درگاه</label>
                <div class="col-lg-6">
                  <input type="text" name="serviceName" class="form-control" v-model="service.title" />
                </div>
              </div>
              <!-- service type -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع درگاه</label>
                <div class="col-lg-6">
                  <select
                    v-model="service.serviceType"
                    class="form-control"
                    name="serviceCat"
                    :disabled="this.$route.query.id"
                  >
                    <option value="" selected disabled>انتخاب کنید</option>
                    <option value="rahpay"> ره پی</option>
                    <option value="zibal">زی پال</option>
                    <option value="zarinpal">زرین پال</option>
                    <option value="parsian">پارسیان</option>
                    <option value="sdk">sdk</option>
                  </select>
                </div>
              </div>

              <!-- service api key -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">
                  api key
                </label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    name="serviceIndex"
                    class="form-control"
                    v-model="service.apiKey"
                    :disabled="this.$route.query.id"
                  />
                </div>
              </div>

              <!-- rahpay terminal id -->
              <div v-if="service.serviceType == 'rahpay'" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">
                  terminal id
                </label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    name="terminalid"
                    class="form-control"
                    v-model="service.terminalId"
                    :disabled="this.$route.query.id"
                  />
                </div>
              </div>
              <!-- service priority -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">اولویت</label>
                <div class="col-lg-6">
                  <input type="number" name="force" class="form-control" min="1" v-model="service.priority" />
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت درگاه</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value="true" :selected="service.isAvailable">فعال</option>
                    <option value="false" :selected="!service.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/pservices">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentServicesService from '../../../../services/paymentServices';
export default {
  name: 'servicedetail',
  data() {
    return {
      service: {},
    };
  },
  created() {
    if (this.$route.query.id) this.getService(this.$route.query.id);
  },
  methods: {
    async getService(id) {
      try {
        const service = await paymentServicesService.findPurchaseServiceById(id);
        this.service = service;
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const form = document.getElementById('serviceForm');
      const body = this.service;
      body.isAvailable = form.isAvailable.value == 'true';
      console.log(body);
      let id;
      try {
        if (this.$route.query.id) {
          await paymentServicesService.updatePaymentService(body);
          id = this.$route.query.id;
        } else {
          const sarvice = await paymentServicesService.creatNewPaymentService(body);
          id = sarvice._id;
          this.$route.query.id = id;
        }

        this.getService(id);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
